import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';

export default function EmptyState({ icon: Icon, title, description, action }) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center animate-fade-in">
      {Icon && (
        <div className="w-14 h-14 rounded-2xl bg-secondary flex items-center justify-center mb-4">
          <Icon className="w-7 h-7 text-muted-foreground" />
        </div>
      )}
      <h3 className="text-base font-semibold text-foreground mb-1">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground max-w-sm mb-5">{description}</p>
      )}
      {action && (
        <Button
          onClick={() => navigate(action.href)}
          className="bg-emerald-600 hover:bg-emerald-700 text-white"
        >
          {action.label}
        </Button>
      )}
    </div>
  );
}
